import BaseBetContainer from 'Engine/containers/ui/BaseBetContainer';

export default class BetContainer extends BaseBetContainer {
  constructor(...arg) {
    super(...arg);
    this.showCurrency = true;
  }
}
